/**
 * Service for detecting user's preferred language
 */

// Supported languages
const SUPPORTED_LANGUAGES = ['en', 'hr', 'de', 'fr'];

// Default language if no match is found
const DEFAULT_LANGUAGE = 'en';

/**
 * Detects user's preferred language based on browser settings
 * @returns {string} The detected language code
 */
export const detectUserLanguage = () => {
  try {
    // Get browser language (e.g., 'en-US', 'de', 'fr')
    const browserLang = navigator.language || navigator.userLanguage;
    
    // Extract primary language code (e.g., 'en' from 'en-US')
    const primaryLang = browserLang.split('-')[0].toLowerCase();
    
    // Check if we support this language
    if (SUPPORTED_LANGUAGES.includes(primaryLang)) {
      return primaryLang;
    }
    
    return DEFAULT_LANGUAGE;
  } catch (error) {
    console.error('Error detecting language:', error);
    return DEFAULT_LANGUAGE;
  }
};

/**
 * Checks if this is the user's first visit to the app
 * @returns {boolean} True if this is the first visit
 */
export const isFirstVisit = () => {
  return localStorage.getItem('language') === null;
}; 